import { render } from "./DocumentEditorActions.vue?vue&type=template&id=2c5f1abd&scoped=true"
import script from "./DocumentEditorActions.vue?vue&type=script&lang=js"
export * from "./DocumentEditorActions.vue?vue&type=script&lang=js"

import "./DocumentEditorActions.vue?vue&type=style&index=0&id=2c5f1abd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5f1abd"]])

export default __exports__